module.exports = __webpack_public_path__ + "static/media/xavier_barbosa(2).d4b20a37.jpg";